import React from "react";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineConfirmationNumber,
  MdOutlineTrackChanges,
} from "react-icons/md";
import { FaHeadset } from "react-icons/fa";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { HiOutlinePencilSquare } from "react-icons/hi2";

const helpOptions = [
  {
    id: 1,
    icon: <MdOutlineConfirmationNumber />,
    title: "My Cashback is Missing",
    path: "/help/missing-cashback",
  },
  {
    id: 2,
    icon: <MdOutlineTrackChanges />,
    title: "Help with Tracked Cashback",
    path: "/my-earnings/order-details",
  },
  {
    id: 3,
    icon: <AiOutlineQuestionCircle />,
    title: "Frequently Asked Questions",
    path: "/help/gethelp",
  },
  {
    id: 4,
    icon: <FaHeadset />,
    title: "Want to Connect with Us",
    path: "/help/chat-with-us",
  },
  {
    id: 5,
    icon: <HiOutlinePencilSquare />,
    title: "Give Us Feedback",
    path: "/help/feedback",
  },
];

const HelpContent = () => {
  const navigate = useNavigate();

  return (
    <>
      <nav className="help-breadcrumb">
        <div className="container">
          <span onClick={() => navigate("/")}>Home</span> / <b>Help</b>
        </div>
      </nav>

      {/* Banner image me pehle se hi "How Can We Help You?" text likha hai */}
      <section className="help-banner">
        <img
          src="/assets/images/banner/help.png"
          alt="How can we help you"
          className="help-banner-img"
        />
      </section>

      <section className="help-cards-section">
        <div className="help-cards-grid">
          {helpOptions.map((opt) => (
            <div
              key={opt.id}
              className="help-card"
              onClick={() => navigate(opt.path)}
            >
              <div className="help-card-icon">{opt.icon}</div>
              <p>{opt.title}</p>
            </div>
          ))}
        </div>
      </section>

      <style jsx>{`
        .help-breadcrumb {
          padding: 12px 0;
          font-size: 0.9rem;
          color: #555;
        }
        .help-breadcrumb span {
          cursor: pointer;
          color: var(--primary)
        }

        .help-banner {
          width: 100%;
          line-height: 0;
        }
        .help-banner-img {
          width: 100%;
          height: auto;
          display: block;
          max-height: 290px;
        }

        .help-cards-section {
          padding: 3rem 1rem;
          display: flex;
          justify-content: center;
        }

        .help-cards-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1.5rem;
          max-width: 1000px;
          width: 100%;
        }

        .help-card {
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.25s ease;

          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          padding: 2.2rem 1.8rem;
          gap: 1.4rem;

          width: 280px;
          min-height: 200px;
          box-sizing: border-box;
        }
        .help-card:hover {
          border-color: #2f5bff;
          box-shadow: 0 6px 16px rgba(47, 91, 255, 0.15);
          transform: translateY(-3px);
        }
        .help-card-icon {
          font-size: 2.4rem;
          color: #2f5bff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .help-card p {
          font-weight: 600;
          margin: 0;
          text-align: left;
          font-size: 1.1rem;
          line-height: 1.4;
          color: #1a2225;
        }

        @media (max-width: 768px) {
          .help-card {
            width: 45%;
          }
        }
        @media (max-width: 480px) {
          .help-card {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default HelpContent;